import React from 'react';
import '../SettingsView.scss';
import 'components/shared/CollectionHeaderBar/CollectionHeaderBar.scss';
import { useBrochureList } from 'api/settings/brochures';
import { HelpOutline } from '@material-ui/icons';
import { BrochureUploader } from './BrochureUploader';
import {
  BrochureManagerContext,
  brochureReducer,
  initialBrochureState,
} from './brochureContext';
import { useBrochureStyles } from './materialStyles';
import { BrochureManagerToolbar } from './BrochureToolbar';

/**
 * @name BrochureManager
 * @description Allow browsing and updating brochure catalog for RV Admin.
 * @see https://www.figma.com/file/UzbAzGFerwBekhrYog9fnK/Velocity-Admin?node-id=6633%3A582
 */

export var BrochureMangerLayout = () => {
  const classes = useBrochureStyles();
  const { data } = useBrochureList();
  const [state, dispatch] = React.useReducer(
    brochureReducer,
    initialBrochureState
  );
  const isInitialState = state.modelOptions.length < 1;
  const ctxState = { ...state, data: data || [] };

  var TitleBar = () => {
    const title = 'Upload Brochure';
    const text = 'Please select make, model and year';
    return (
      <div className={classes.uploadContainer}>
        <div className={classes.uploadContainer}>
          <div>
            <HelpOutline className={classes.uploadIcon} />
          </div>
          <span className={classes.uploadTitle}>{title}</span>
          <div className={classes.uploadText}>{text}</div>
        </div>
      </div>
    );
  };

  return (
    <BrochureManagerContext.Provider value={{ state: ctxState, dispatch }}>
      <BrochureManagerToolbar />
      {isInitialState ? <TitleBar /> : <BrochureUploader />}
    </BrochureManagerContext.Provider>
  );
};

export default BrochureMangerLayout;
